import { Avatar } from 'Elements';
import styles from 'partials/user-story-card.module.scss';

export const UserStoryCard = ({ user }) => {
	return (
		<div className={styles.user}>
			<Avatar
				src={user?.avatar}
				alt={user?.name}
				className={styles.avatar}
			/>
			<span className={styles.name}>{user?.name || 'مدیر سایت'}</span>
		</div>
	);
};